module.exports = __webpack_public_path__ + "img/DiscordV2-Hover.fd9fb4ee.webp";